<template>
    <div class="clearfix userCenterView address">
        <Form ref="form" @submitSuccess="addAddressSuccess" @editSuccess="editAddressSuccess" />
        <div class="fr"><Bread :prop="bread" /></div>
        <div class="contentWrap fl"  style="width:100%">
            <div class="contentTitle">收货地址</div>
            <div class="content">
                <div class="colorBlue csp addressButton" @click="addAddress()"><span class="el-icon-plus mr5"></span>新增收货地址</div>
                <div class="address">
                   <div v-for="(item,index) in addressData.list" :key="index" class="addressDiv" :class="item.is_default === 1 ? 'default' : ''">
                       <div style="line-height: 15px;">
                           <span class="is_default" v-if="item.is_default === 1">默认</span>
                           <span style="margin-right:8px;">{{ item.consignee }}</span>
                           <span>{{ item.mobile }}</span>
                        </div>
                        <div style="margin-top: 15px;">
                            {{ item.area }}
                        </div>
                        <div class="op">
                            <div class="opbutton" @click="setDefault(item)"><i class="iconTick iconfont icon"></i>设为默认</div>
                            <div>|</div>
                            <div class="opbutton" @click="editAddress(item)"><i class="iconbianji iconfont icon"></i>编辑</div>
                            <div>|</div>
                            <div class="opbutton" @click="delect(item)"><i class="iconshanchu iconfont icon"></i>删除</div>
                        </div>
                   </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Bread from '@/components/Bread/index.vue'
import Form from './formAddress'
import { UserCenterService } from '../../../service/userCenter.service'

  export default {
    data() {
      return {
        bread: [{
            name: '用户中心',
            path: '/userCenter/index'
        },{
            name: '收货地址',
            path: '/userCenter/address'
        }],
        addressData: []
      }
    },
    components: {Bread,Form},
    methods: {
        async getList() {
            const data = await UserCenterService.getList()
            this.addressData = data
        },
        addAddress() {
            this.$refs.form.open('add')
        },
        editAddress(val) {
            this.$refs.form.open('edit',val)
        },
        async setDefault(val) {
            await UserCenterService.addressDefault(val.address_id)
            this.addressData.list.map(v=>{
                if(v.address_id === val.address_id) {
                    v.is_default = 1
                }else{
                    v.is_default = 0
                }
            })
        },
        addAddressSuccess(data) {
            if(data.is_default===1) {
                this.addressData.list.map(v=>{
                    v.is_default = 0
                })
            }
            this.addressData.list.push(data)

        },
        editAddressSuccess(data) {
            let that = this
            if(data.is_default===1) {
                this.addressData.list.map(v=>{
                    v.is_default = 0
                })
            }
            this.addressData.list.map((v,index)=>{
                if( v.address_id == data.address_id) {
                    that.$set(this.addressData.list,index,data)
                }
            })
        },
        async delect(val) {
            await this.$confirm('确定删除该地址吗？');
            await UserCenterService.delectAddress(val.address_id)
            this.addressData.list = this.addressData.list.filter(it => it.address_id !== val.address_id)
            this.$message.success('删除成功！');
        }
    },
    created() {
        this.getList()
    }
  }
</script>

<style lang="scss" scoped>
    .userCenterView.address{
        width: 935px;
        .content{
            padding: 40px 30px 50px 30px;
            border: 1px solid #e3e2e1;
            display: block;
            .el-input{
                width: 300px
            }
            .addressButton{
                display: inline;
                background: rgb(29, 144, 208);
                border: 1px solid #1177b6;
                color: #fff;
                padding: 5px 10px;
            }
            .addAddress{
                position: fixed;
                background: #fff;
                border: 1px solid #e3e2e1;
                box-shadow: 0 0 1px #6f6f6f;
                left: 50%;
                transform: translateX(-50%);
                z-index: 5;
                top: 100px;
                .addAddressTitle{
                    height: 40px;
                    line-height: 40px;
                    font-size: 18px;
                    color: #999;
                    padding-right: 15px;
                    background: #eee;
                    .el-icon-circle-close{
                        cursor: pointer;
                    }
                }
            }
            .address{
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                margin-top: 15px;
                .addressDiv{
                    width: 260px;
                    height: 100px;
                    background: url('../../../assets/images/views/address-peraddbg.png');
                    background-size: 100% 100%;
                    margin-bottom: 8px;
                    padding: 15px 10px;
                    margin-right: 10px;
                }
                .addressDiv.default{
                    background-image: url('../../../assets/images/views/address-peraddressbg.png')
                }
            }
            
        }
    }
    .iconiconfontxiaogantanhao{
        font-size: 24px;
        vertical-align: sub;
        margin-right: 8px;
    }
    .is_default{
        background: #5eb95e;
        padding: 0.25em 0.5em;
        border-radius: 2px;
        color: #fff;
        margin-right: 15px;
    }
    .op{
        display: flex;
        margin-top: 40px;
        justify-content: flex-end;
        .opbutton{
            padding: 0 8px;
            cursor: pointer;
            i{
              vertical-align: -1px;
            }
        }
        .opbutton:hover{
            color: #d2364c;
        }
    }
</style>

<style lang="scss">
    .area-select-wrap{
        .area-select{
            border: 1px solid #B9B9B9;
            border-radius: 0;
            height: 35px;
            .area-selected-trigger{
                line-height: 20px;
            }
        }
        .area-select:first-child{
            margin-left: 0;
        }
        
    }
</style>